import { render, staticRenderFns } from "./MajorityTextfield.vue?vue&type=template&id=722b781c&"
import script from "./MajorityTextfield.vue?vue&type=script&lang=js&"
export * from "./MajorityTextfield.vue?vue&type=script&lang=js&"
import style0 from "./MajorityTextfield.vue?vue&type=style&index=0&id=722b781c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports